import { render, staticRenderFns } from "./PopupOrderError.vue?vue&type=template&id=f56f79f4&scoped=true&"
import script from "./PopupOrderError.vue?vue&type=script&lang=js&"
export * from "./PopupOrderError.vue?vue&type=script&lang=js&"
import style0 from "./PopupOrderError.vue?vue&type=style&index=0&id=f56f79f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f56f79f4",
  null
  
)

export default component.exports